import "./MonthlyOverview.scss";

export default function MonthlyOverview() {
  return (
    <section className="sales-layout__page monthly-overview">
      <h1>Monatsübersicht</h1>
      <p>Hier werden zukünftig die Monatsübersichten angezeigt.</p>
    </section>
  );
}
